import {Component, computed, effect, HostListener, OnInit, signal, WritableSignal} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {
    CategoriaTramiteEnum,
    FasesTabItem,
    TramiteItem,
    TramitesRequisitosInterface
} from '../interfaces/tramites.interface';
import {map, throwError} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ProyectoItem, ProyectoTramiteItem} from '../../../interfaces/proyecto.interface';
import {LayoutService} from 'src/app/layout/service/app.layout.service';
import {Table} from "primeng/table";
import {style} from "@angular/animations";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {TramiteService} from "../../services/tramite.service";
import {SdetTramiteService} from "../../services/sdet-tramite.service";
import {RandomSessionIdService} from "../../../../guards/random-session-id.service";
import {UserSessionReq} from "../../../../shared/interfaces/user-session-req-interface";
import {SdetInterface} from "../interfaces/sdet.interface";
import {TramiteRequisitoService} from "../../../mnto-master/services/tramite-requisito.service";
import Swal from "sweetalert2";
import {ProyectoService} from "../../../proyectos/services/proyecto.service";
import {EliminarTramiteService} from "../../../pagos/services/eliminar-tramite.service";

@Component({
    selector: 'tramites-disponibles',
    templateUrl: './tramites-disponibles.component.html',
    styleUrls: ['./tramites-disponibles.component.css'],
    providers: [MessageService, ConfirmationService]
})
export class TramitesDisponiblesComponent implements OnInit {
    constructor(public layoutService: LayoutService, protected tramite: TramiteService,
                private route: ActivatedRoute, public loginServices: LoginServices,
                public solicitudDetService: SdetTramiteService, private messageService: MessageService,
                private confirmationService: ConfirmationService,
                private randomSessionIdService: RandomSessionIdService, private tramiteRequisitoService: TramiteRequisitoService,
                private proyectoService: ProyectoService, protected eliminarTramiteService: EliminarTramiteService) {
        this.sessionId = this.randomSessionIdService.randomSessionId();
    }

    idFase: WritableSignal<number | null> = signal(null)
    loading: WritableSignal<boolean> = signal(false)
    pageLoad: WritableSignal<boolean> = signal(true)
    tabLoad: WritableSignal<boolean> = signal(false)
    isPrjReady = computed(() => this.tramite.selected() != null);
    tramitesPorFase = computed(() => this.tramite.tramitesPorFase());
    fases: FasesTabItem[] = []
    faseActiva: FasesTabItem = this.fases[0]
    requisitosPorTramite: TramitesRequisitosInterface[] = []
    requisitosPorTramiteMenu: MenuItem[] = []
    showRequisitos: boolean = false
    selectedService: number | null = null
    servicioRequisito: string = null!
    prjId$ = this.route.params.pipe(map((params) => params['idProyecto']));
    sessionId: string | null
    protected readonly JSON = JSON;
    visibleDialogTramitesExpres: boolean = false;
    tramiteSelectedExpres!: TramiteItem
    visibleSeletedDlg: boolean = false;
    tramiteSelected!: TramiteItem // variable para dialog de tramite seleccionado por rol administrado.ti
    ngOnInit() {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.preFetchDatos()
    }

    preFetchDatos() {
        this.resetStatus()
        this.tramite.resetStatus()
        this.prjId$.subscribe((id) => {
            if (id) {
                this.tramite.idProyecto.set(id)
                this.tramite.getInitPayload(id)
            }
        });
    }

    getRequisitosTramitePorTipo(idTramite: string, servicio: string) {
        let finalIdTramite = Number.parseInt(idTramite);
        this.loading.set(true)
        this.showRequisitos = true
        this.servicioRequisito = servicio
        this.tramiteRequisitoService.getRequisitosTramitePorTipo(finalIdTramite)
            .subscribe(
                resp => {
                    let requisitos_list: MenuItem[] = []
                    for (let i of resp) {
                        let requisitos: MenuItem[] = []
                        for (let j of i.requisitos) {
                            let icono = ''
                            if (j.aplicaCargaDocumento) {
                                icono = 'pi pi-upload'
                            } else if (!j.aplicaFormulario) {
                                icono = 'pi pi-book'
                            }
                            let requisito: MenuItem = {
                                label: j.nombre,
                                icon: icono,
                                badge: j.tipoTramite,
                                id: j.idRequisito
                            }
                            requisitos.push(requisito)
                        }
                        let icono_menu = ''
                        if (i.descripcion.toLowerCase() == 'carga') {
                            icono_menu = 'pi pi-upload'
                        } else if (i.descripcion.toLocaleLowerCase() == 'complemento') {
                            icono_menu = 'pi pi-plus'
                        } else if (i.descripcion.toLocaleLowerCase() == 'validacion') {
                            icono_menu = 'pi pi-check'
                        }
                        let requisito: MenuItem = {
                            label: i.descripcion + ` (${i.requisitos.length})`,
                            icon: icono_menu,
                            items: requisitos
                        }
                        requisitos_list.push(requisito)
                    }
                    console.log("this.requisitosPorTramiteMenu", this.requisitosPorTramiteMenu.length)
                    console.log("this.requisitosPorTramite", this.requisitosPorTramite.length)
                    this.requisitosPorTramiteMenu = requisitos_list
                    this.requisitosPorTramite = resp
                    this.loading.set(false)
                }
            )
    }

    agregarTramite(tramite: TramiteItem, index: number) {
        console.log("####################################################################")
        console.log(`agregarTramite->i:${index},t:${JSON.stringify(tramite)}`)
        if (!this.tramite.selected()) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Proyecto es requerido para continuar'
            });
            return
        }
        this.selectedService = index
        this.loading.set(true)
        const currentSession: UserSessionReq = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        };
        const sdet: SdetInterface = {
            codigoInstitucion: tramite.codigoInstitucion ? parseInt(tramite.codigoInstitucion) : 0,
            idTramite: tramite.idTramite ? parseInt(tramite.idTramite) : 0,
            codigoProyecto: this.tramite.selected()!.idProyecto,
            codigoSolicitud: this.tramite.selected()!.idSolicitud,
            idFase: Number.parseFloat(tramite.idFase),
            usuario: currentSession.usuario,
            session: currentSession,
            idsTramites:tramite.idsTramites,
            comentario:this.eliminarTramiteService.textChangeEditor() != null ? this.eliminarTramiteService.textChangeEditor() : null
        };
        setTimeout(() => {//Timeout es requerido para mostrar animacion en pantalla.
            this.solicitudDetService.createSdet(sdet)
                .subscribe({
                    next: (resp) => {
                        if (resp) {
                            if (resp.status == 200 || resp.status == 201 || resp.status == 204) {
                                let idProyecto = resp.body! //esta variable esta vacia
                                this.tramite.idProyecto.set(this.tramite.selected()!.idProyecto.toString()!)
                                this.consultarTramites(this.tramite.selected()!.idProyecto.toString())
                                this.generalesProyectoUpdate();
                            }
                        }
                    },
                    error: (error) => {
                        this.loading.set(false)
                        if (error.status == 403) {
                            Swal.fire({
                                position: "center",
                                icon: "warning",
                                title: "Acción no permitida no fue posible agregar el trámite",
                                showConfirmButton: true,
                                timer: 5000
                            })
                        } else {
                            Swal.fire({
                                position: "center",
                                icon: "error",
                                title: error.error.mensaje,
                                showConfirmButton: true,
                                timer: 5000
                            })
                        }

                        return throwError(() => error);
                    },
                    complete: () => {
                        this.selectedService = null
                        this.loading.set(false)
                        this.consultarTramites()// consulta los tramites
                    }
                });
        }, 300);
    }

    confirmAgregarTramite(event: Event, tramite: TramiteItem, index: number) {
        console.log(`tramite -> ${JSON.stringify(tramite)}`)
        if (this.tramite.selected() == null || this.tramite.selected() == undefined) {
            this.confirmationService.confirm({
                target: event.target as EventTarget,
                message: 'Proyecto es requerido para continuar',
                header: 'Confirmar',
                icon: 'pi pi-exclamation-triangle',
                acceptButtonStyleClass: 'p-button-success p-button-sm',
                rejectButtonStyleClass: "p-button-text p-button-sm",
                acceptLabel: "Si, proceder",
                rejectLabel: "Cancelar",
                acceptIcon: "pi pi-check",
                rejectIcon: "none",
                accept: () => {
                    // this.agregarTramite(tramite, index);
                },
                reject: () => {
                    this.messageService.add({
                        severity: 'warn',
                        detail: 'Operación cancelada'
                    });
                }
            });
        } else {
            if (this.loginServices.hasRoles(['cliente_ventanilla'])) {
                if (tramite.idCategoria == CategoriaTramiteEnum.ServicioOnlineTramiteExpresIndividual.toString()) {
                    this.visibleDialogTramitesExpres = true;
                    this.tramiteSelectedExpres = tramite;
                    this.selectedService = index;
                } else {
                    this.agregarTramite(tramite, index);
                }
            } else if (this.loginServices.hasRoles(['administrador.ti','gerente','tecnico_resolutor','jefe.registro','tecnico.registro'])) {
                if (tramite.idCategoria == CategoriaTramiteEnum.ServicioOnlineTramiteExpresIndividual.toString()) {
                    this.visibleDialogTramitesExpres = true;
                    this.tramiteSelectedExpres = tramite;
                    this.selectedService = index;
                } else {
                    this.visibleSeletedDlg = true;
                    this.tramiteSelected = tramite;
                }
            } else {
                console.log("rol no definido para este criterio")
            }

        }
    }

    consultarTramites(idProyecto?: string) {
        let perfil = this.loginServices.session()?.perfil;
        if (idProyecto) {
            console.log(`CASO 0: por idProyecto param=> institucion:${perfil!.idInstitucion.toString()}, fase:${this.idFase()}, idProyecto:${idProyecto}`);
            this.tramite.getTramitesDisponibles(perfil!.idInstitucion!, this.idFase()!, Number.parseFloat(idProyecto!))
        } else if (this.tramite.selected()) {
            console.log(`CASO 1: por idProyecto selected=> institucion:${perfil!.idInstitucion.toString()}, fase:${this.idFase()}, idProyecto:${this.tramite.selected()!.idProyecto}`);
            this.tramite.getTramitesDisponibles(perfil!.idInstitucion!, this.idFase()!, this.tramite.selected()!.idProyecto)
        } else {
            console.log(`CASO 2: por idFase=> institucion:${perfil!.idInstitucion.toString()}, fase:${this.idFase()}`);
            this.tramite.getTramitesDisponibles(perfil!.idInstitucion!, this.idFase()!, 0)
        }
    }
    //Metodo para actualizar las generales del proyecto al seleccionar tramites
    private generalesProyectoUpdate() {
        this.prjId$.subscribe((id) => {
            if (id) {
                this.tramite.getGeneralesProyectoUpdate(id);
            }
        });
    }

    initPayloadChangedEffect = effect(() => {
        if (this.tramite.initPayload()) {
            this.tramite.selected.set(this.tramite.initPayload()?.p!);
            let items: FasesTabItem[] = this.tramite.initPayload()!.f
            items.forEach(item => {
                if (!item.disabled) {
                    item.command = (event: any) => {
                        console.log(`command ->${JSON.stringify(event)}`)
                        this.idFase.set(Number.parseFloat(event.item.idFase));
                        this.faseActiva = item;
                        this.tabLoad.set(true)
                        this.consultarTramites();
                    }
                }
            })
            this.fases = items
            this.faseActiva = this.fases.filter(value => !value.disabled)[0];
            this.idFase.set(this.faseActiva.idFase)
            setTimeout(() => {
                this.pageLoad.set(false)
            }, 200);
        }
        console.log(`#DEBUG initPayload loaded [${this.tramite.initPayload() != null}]`)
    }, {allowSignalWrites: true})
    tramitesChangedEffect = effect(() => {
        console.log(`tramitesChangedEffect ->${this.tramitesPorFase().length}`)
        if (this.tabLoad() && this.tramitesPorFase().length > 0) {
            setTimeout(() => {
                this.tabLoad.set(false)
            }, 50);
        }
    })
    faseChangedEffect = effect(() => {
        console.log(`faseChangedEffect ->${this.idFase()}`)
    })

    clear(table: Table) {
        table.clear();
    }

    resetStatus() {
        this.tramite.idProyecto.set(null)
        this.tramite.selected.set(null)
    }
    onEventEmitterClose(event: boolean) {
        this.visibleDialogTramitesExpres=event;
    }
    onEventEmitterProcesar(tramitesSeleccionados: ProyectoTramiteItem[]) {
        if (tramitesSeleccionados && tramitesSeleccionados.length > 0) {
            const idsTramites = tramitesSeleccionados.map(t => parseInt(t.idTramite));
            this.tramiteSelectedExpres = {...this.tramiteSelectedExpres,
                idsTramites: idsTramites};
            this.agregarTramite(this.tramiteSelectedExpres,this.selectedService!);
        }
    }
    onDialogClosedSelected(event: boolean) {
        this.visibleSeletedDlg = event;
        if (!this.visibleSeletedDlg) { // se cerro el dialogo porque fue exito o dio click en cancelar
            this.loading.set(false);
            this.consultarTramites(this.tramite.selected()!.idProyecto.toString())
            this.generalesProyectoUpdate();
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
        console.log('#DEBUG Page refresh detected');
        this.resetStatus()
        this.tramite.resetStatus()
    }

    @HostListener('window:unload', ['$event'])
    handleUnload(event: Event): void {
        console.log('#DEBUG: Page fully unloaded');
        this.resetStatus()
        this.tramite.resetStatus()
    }

    ngOnDestroy(): void {
        console.log(`ngOnDestroy ->${this.constructor.name}` + new Date().toISOString());
        this.resetStatus()
        this.eliminarTramiteService.textChangeEditor.set(null);
    }


    protected readonly style = style;
}
